import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterTagType_template} from "./filterTagType_template";
import {filterDataset_template} from "./filterDataset_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {tagStore_template} from "./tagStore_template";
import {tagStore_helper} from "../../modules/tagStore_helper";

declare var ko: any;

export class tagsList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected isActiveFilter: multipleSelector_template;
    protected isAvailableFilter: multipleSelector_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected tagTypeFilter: filterTagType_template;
    protected datasetFilter: filterDataset_template;
    protected filterPreset: filterPreset_template;
    public tagStore: tagStore_template;
    public tagStoreHelper: tagStore_helper;

    protected getTemplateHtml(): string {

        return /* html */`

            <div class="sub-header w-justify">
                <div class="w-left">
                    <div>${this.datasetFilter.getHtmlBuild()}</div>
                    <div>
                        ${ this.tagTypeFilter.getHtmlBuild() }
                    </div>
                <!-- ko if: !showActiveFilter -->
                    <div>
                        ${ this.isActiveFilter.getHtmlBuild() }
                    </div>
                    <div>
                    ${ this.isAvailableFilter.getHtmlBuild() }
                    </div>
                <!-- /ko -->
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-tag-types"></div>
                    <div id="selected-dataset"></div>
                    <!-- ko if: !showActiveFilter -->
                    <div id="selected-active"></div>
                    <div id="selected-available"></div>
                    <!-- /ko -->
                </div>
            </div>

            <div class="list-header w-justify" >
                <div class="w-left">

                    <div data-bind="ifnot: idBrand">
                        <button data-bind=" click: onClickShowPopUp" class="btn secondary icon i-add" type="button">Add Tag</button>
                    </div>

                    <div class="form-check-inline" data-bind="if: idBrand">
                        <button class="btn secondary icon i-add" type="button" data-bind="click: onClickImportTags, visible: showImportButton()">Import tags</button>
                        <button class="btn secondary icon i-add" type="button" data-bind="click: onClickAddTag, visible: showAddTagButton()">Add tag</button>
                    </div>

                </div>

                <div class="w-center">
                    ${ this.filter.getHtmlBuild() }
                </div>

                <div class="w-right">
                    <div data-bind="style: { display: paginationIsVisible() ? 'block' : 'none' }">
                        <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                            <div class="pagination">
                                <input data-bind="value: pageNumber" type="hidden" value="1">
                                <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                                <ul data-bind="foreach: pages">
                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                                </ul>
                                <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${ this.resultInfos.getHtmlBuild() }
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tagType') }, css: { 'list-sort-desc': orderByAndDirection()=='tagType_DESC', 'list-sort-asc': orderByAndDirection()=='tagType_ASC' }">Tag Type</span></th>
                            <th data-bind="visible: idBrand"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': orderByAndDirection()=='articleCount_DESC', 'list-sort-asc': orderByAndDirection()=='articleCount_ASC' }">Article Count</span></th>
                            <th data-bind="visible: idBrand"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isSelectable') }, css: { 'list-sort-desc': orderByAndDirection()=='isSelectable_DESC', 'list-sort-asc': orderByAndDirection()=='isSelectable_ASC' }" class="icon i-dropdown-simple">Article Categorizable</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: tags">

                        <tr class="cursor" >
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: type"></span></a></td>
                            <td data-bind="visible:$parent.idBrand, event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: articleCount"></span></a></td>
                            <td data-bind="visible:$parent.idBrand, event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: isSelectable"></span></a></td>
                        </tr>

                    </tbody>
                </table>
            </div>


          <div id="create-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Create Tag</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <label class="form-label">Name</label>
                                <div class="w-input">
                                    <input type="text" name="name" id="name"  class="input-text" data-bind="value: name">
                                </div>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn border only-icon icon">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSave }" class="btn border only-icon icon">Save</button>
                        </div>
                    </div>

                </div>
            </div>

            ${this.tagStore.getHtmlBuild()}
            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)

        this.tagTypeFilter = new filterTagType_template("tagTypeFilter", this.getTemplateViewModel(), this.caller);
        this.tagTypeFilter.asMultipleSelectionMode();

        this.datasetFilter = new filterDataset_template("datasetFilter", this.getTemplateViewModel(), this.caller);

        this.isActiveFilter = new multipleSelector_template("isActiveFilter", this.getTemplateViewModel(), this.caller);
        this.isActiveFilter.setLabel("Active");
        this.isActiveFilter.setFilterContainerClass('margin-neg');
        this.isActiveFilter.setTagContainerId('selected-active');
        this.isActiveFilter.setTagContainerCaption('Selected active:');

        this.isAvailableFilter = new multipleSelector_template("isAvailableFilter", this.getTemplateViewModel(), this.caller);
        this.isAvailableFilter.setLabel("Available for Article Categorization");
        this.isAvailableFilter.setFilterContainerClass('margin-neg');
        this.isAvailableFilter.setTagContainerId('selected-available');
        this.isAvailableFilter.setTagContainerCaption('Selected available:');

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('tags-list');
        
        this.tagStore = new tagStore_template("tagStore", this.getTemplateViewModel(), this.caller);
        this.tagStoreHelper = new tagStore_helper(this.tagStore, this.caller.getVnAppZone(), this.caller);
        this.tagStore.setCaller(this.tagStoreHelper);
    }

    protected getTemplateName(): string {
        return "tagsList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        let vm =  {
            orderBy: ko.observable("id")
            , idBrand: ko.observable(null)
            , orderByDirection: ko.observable("DESC")
            , tags: ko.observableArray([])
            , datasets: ko.observableArray([])
            , orderByAndDirection: ko.observable("id_DESC")
            , isAddButtonShown: ko.observable(true)
            , name : ko.observable()
            , showImportButton: ko.observable(false)
            , showAddTagButton: ko.observable(false)
            , paginationIsVisible: ko.observable(false)
            , onClickImportTags: this.onClickImportTags.bind(this)
            , onClickAddTag: this.onClickAddTag.bind(this)
            , showActiveFilter: ko.pureComputed(() => {
                let idBrand = vm.idBrand();
                return idBrand == null;
            })
            , onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            }
            , onClickSave: function () {
                self.onClickSave();
            },
            onClickShowPopUp: function () {
                self.onClickShowPopUp()
            },
            onClickHidePopUp: function () {
                self.onClickHidePopUp()
            },
            onClickView: function (value) {
                self.onClickView(value);
            },
            showSelectableTags: function (data) {
                self.showSelectableTags();
                return true;
            }
        };

        return vm;
    }

    // tag save model
    public buildTagViewModel(){

        return {

            name: this.getTemplateViewModel().name
        }

    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest(countOnly: boolean = false) {

        const showActiveFilter =this.getTemplateViewModel().showActiveFilter();

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            isActiveFilter: this.getTemplateViewModel().isActiveFilter,
            isAvailableFilter: this.getTemplateViewModel().isAvailableFilter,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: 'tags-list',
            countOnly: countOnly,
            filters      : {
                keyword : this.getTemplateViewModel().filter.filterKeyword,
                tagTypeName: this.getTemplateViewModel().tagTypeFilter.tagType,
                tagTypes: this.tagTypeFilter.getTagsForRequest(),
                idDataset: this.getTemplateViewModel().datasetFilter.idDataset,
                datasetTagType: this.getTemplateViewModel().datasetFilter.idTagType,
                isActive: showActiveFilter ? this.getTemplateViewModel().isActiveFilter.selectedItems : [1],
                isAvailable: this.getTemplateViewModel().isAvailableFilter.selectedItems,
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.tagsListReorder();
    }

    public onClickSave() {

        this.toggleDeleteDialogVisibility();
        this.caller.saveTag();
    }

    public onClickShowPopUp() {

        this.caller.createTag();
    }

    public onClickHidePopUp() {

        this.toggleDeleteDialogVisibility();
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('create-dialog').classList.toggle('is-visible');
    }

    public setTags(tags) {

        this.getTemplateViewModel().tags(tags);
    }

    public setAddButtonShown(isAddButtonShown: boolean) {

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
        // this.resultInfos.setExecutionTime(execTime);
    }

    public setExecutionTime(execTime){
        this.resultInfos.setExecutionTime(execTime);
    }

    public onClickView(value) {

        this.caller.viewTag(value.id);
    }

    public showSelectableTags(){

        this.caller.showSelectableTags();
    }

    public setIdBrand(idBrand): void {

        this.getTemplateViewModel().idBrand(idBrand);
    }

    protected setTagTypeFilter(tagTypes) {

        this.getTemplateViewModel().tagTypeFilter.tagTypes(tagTypes);
    }

    protected setDatasetFilter(datasets) {

        this.getTemplateViewModel().datasetFilter.datasets(datasets);
    }
    protected setTagTypeDropdown(tagTypes) {
        this.getTemplateViewModel().datasetFilter.dataTypeOptions(tagTypes);
    }

    public setShowImportButton(showImportButton) {

        this.getTemplateViewModel().showImportButton(showImportButton);
    }

    public setShowAddTagButton(showAddTagButton) {

        this.getTemplateViewModel().showAddTagButton(showAddTagButton);
    }

    public setSearchPresets(presets) {
        this.filterPreset.setSearchPresets(presets);
    }

    public setActiveFilterItems(items) {
        this.isActiveFilter.setItems(items);
    }

    public setAvailableFilterItems(items) {
        this.isAvailableFilter.setItems(items);
    }

    private onClickImportTags() {
        this.caller.importTags();
    }

    private onClickAddTag() {
        this.tagStore.openTagStore();
    }

    public setFilterSelectedItems(objFilter, urlParams){
        let splitString = [];

        // Multi select filters.
        if(Array.isArray(urlParams)){
            urlParams = urlParams.toString();
        }
        if(urlParams || urlParams === 0) {
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {

                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public setViewModelFromRequest(urlParams) {
        const {isActive, isAvailable, tagTypes} = urlParams


        if (urlParams != null) {
            const newUrlParams = {
                isActiveFilter: isActive,
                isAvailableFilter: isAvailable,
                tagTypeFilter: tagTypes,
            }
            this.setFilterSelectedItems(this.isActiveFilter, newUrlParams.isActiveFilter);
            this.setFilterSelectedItems(this.isAvailableFilter, newUrlParams.isAvailableFilter);
            this.tagTypeFilter.setSelectedItems(newUrlParams.tagTypeFilter);
        }
    }

    public setDefaultFilters() {
        this.setFilterSelectedItems(this.isActiveFilter, 1);
        this.setFilterSelectedItems(this.isAvailableFilter, [0,1]);
    }
    public deleteAllSelectedTagType() {
        this.getTemplateViewModel().tagTypeFilter.tagTypes([]);
        this.tagTypeFilter.setTagTypes([]);
        this.tagTypeFilter.setSelectedItems([]);
        this.tagTypeFilter.removeAllTagTypessFromSelection();
        this.tagTypeFilter.resetTagContainer();
        this.caller.filterList();
    }

    public setPaginationIsVisible(isVisible){
        this.getTemplateViewModel().paginationIsVisible(isVisible);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagsList_template.ts